// Pure helpers for the user's quiet-hours window. All times are user-local
// "HH:MM" strings. The window supports wrap-around (e.g. 22:00 -> 07:00).

export const parseHHMM = (s) => {
  if (typeof s !== "string") return null;
  const m = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(s);
  if (!m) return null;
  return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
};

export const nowMinutes = (date = new Date()) =>
  date.getHours() * 60 + date.getMinutes();

export const isInQuietWindow = (prefs, date = new Date()) => {
  if (!prefs || !prefs.quiet_enabled) return false;
  const start = parseHHMM(prefs.quiet_start);
  const end = parseHHMM(prefs.quiet_end);
  if (start == null || end == null) return false;
  if (start === end) return false; // zero-length window = never
  const t = nowMinutes(date);
  if (start < end) {
    // Same-day window: [start, end)
    return t >= start && t < end;
  }
  // Wrap-around window: [start, 24:00) or [00:00, end)
  return t >= start || t < end;
};
